export default {
  ja:[
    "あなたのアイデアが選ばれました！",
    "提案者",
    "値段",
    "円",
    "状態",
    "新品",
    "中古",
  ],
  en: [
    "You’ve decided to go with this request!",
    "Proposer",
    "Price",
    "JPY",
    "State",
    "New",
    "Used",
  ]
}
